export default __webpack_public_path__ + "static/media/Front Centre.e01e0329.jpg";